/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React from "react";
import { connect } from "react-redux";
import { Nav, Tab } from "react-bootstrap";
import SideBarNavigationTabAction from './CustomControl/SideBarNavigationTabAction';
import TabAction from './CustomControl/TabAction';

class ContractSidePanelAction extends React.Component {
    state = { selectedTab: "1" };
    setTab = _tabName => {
        this.setState({ selectedTab: _tabName });
    };


    render() {
        if (!this.props.contractTemplate || !this.props.filteredManualActions) {
            return null;
        }
        const { contractTemplate, filteredManualActions } = this.props;

        return (
            <Tab.Container defaultActiveKey={this.state.selectedTab}>
                <div style={{ marginTop: "2rem" }} className="kt-quick-panel__nav">
                    <Nav
                        onSelect={this.setTab}
                        className="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand kt-notification-item-padding-x"
                    >
                        <SideBarNavigationTabAction
                            partyHasRoleInContract={this.props.contractTemplate.parties.supplierExist}
                            title={contractTemplate.resources.SUPPLIER_NAME}
                            eventKey="1"
                            actions={filteredManualActions.SUPPLIER}
                        />
                        <SideBarNavigationTabAction
                            partyHasRoleInContract={this.props.contractTemplate.parties.pmExist}
                            title={contractTemplate.resources.PM_NAME}
                            eventKey="2"
                            actions={filteredManualActions.PM}
                        />
                        <SideBarNavigationTabAction
                            partyHasRoleInContract={this.props.contractTemplate.parties.supervisorExist}
                            title={contractTemplate.resources.SUPERVISOR_NAME}
                            eventKey="3"
                            actions={filteredManualActions.SUPERVISOR}
                        />
                        <SideBarNavigationTabAction
                            partyHasRoleInContract={this.props.contractTemplate.parties.clientExist}
                            title={contractTemplate.resources.CLIENT_NAME}
                            eventKey="4"
                            actions={filteredManualActions.CLIENT}
                        />
                    </Nav>
                </div>
                <div className="kt-quick-panel__content">
                    <Tab.Content>
                        <Tab.Pane eventKey="1">
                            <TabAction
                                key={filteredManualActions.lastLoadedEpochTime  + "SUPPLIER"}
                                panelCloseBtnRef={this.props.panelCloseBtnRef}
                                contractid={this.props.contractid}
                                isOpen={this.props.isOpen}
                                actionsObj={filteredManualActions.SUPPLIER}
                                skey={filteredManualActions.lastLoadedEpochTime  + "SUPPLIER"}
                            />
                        </Tab.Pane>
                        <Tab.Pane eventKey="2">
                            <TabAction
                                key={filteredManualActions.lastLoadedEpochTime  + "PM"}
                                panelCloseBtnRef={this.props.panelCloseBtnRef}
                                contractid={this.props.contractid}
                                isOpen={this.props.isOpen}
                                actionsObj={filteredManualActions.PM}
                                skey={filteredManualActions.lastLoadedEpochTime  + "PM"}
                            />
                        </Tab.Pane>
                        <Tab.Pane eventKey="3">
                            <TabAction
                                key={filteredManualActions.lastLoadedEpochTime  +  "SUPERVISOR"}
                                panelCloseBtnRef={this.props.panelCloseBtnRef}
                                contractid={this.props.contractid}
                                isOpen={this.props.isOpen}
                                actionsObj={filteredManualActions.SUPERVISOR}
                                skey={filteredManualActions.lastLoadedEpochTime  +  "SUPERVISOR"}
                            />
                        </Tab.Pane>
                        <Tab.Pane eventKey="4">
                            <TabAction
                                key={filteredManualActions.lastLoadedEpochTime  + "CLIENT"}
                                panelCloseBtnRef={this.props.panelCloseBtnRef}
                                contractid={this.props.contractid}
                                isOpen={this.props.isOpen}
                                actionsObj={filteredManualActions.CLIENT}
                                skey={filteredManualActions.lastLoadedEpochTime  + "CLIENT"}
                            />
                        </Tab.Pane>
                    </Tab.Content>
                </div>
            </Tab.Container>
        );
    }
}

const mapStateToProps = store => ({
    contractDashboard: store.contract.dashboard,
    contractTemplate: store.contract.template,
    filteredManualActions: store.contract.filteredManualActions,
});

export default connect(mapStateToProps)(ContractSidePanelAction)